// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "undefined_styles" + "." + "bdd4b639" + ".chunk.css";
};